import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { IRootState, IRootThunkDispatch } from '../../redux/store';
import { restoreCmsLogin } from '../../redux/auth/thunk';



function CMSRoute({children}:{children:JSX.Element}) {

    const location = useLocation();
    const navigate = useNavigate();
    const isAuthenticated = useSelector((state:IRootState)=>state.userAuth.isAuthenticated)
    const dispatch = useDispatch<IRootThunkDispatch>() 
    useEffect(()=>{
      if (isAuthenticated === null){
        dispatch(restoreCmsLogin(navigate));
      }
    },[dispatch,isAuthenticated,navigate])
  
    return isAuthenticated?children:<Navigate to={'/'} state={{from:location}} replace/>


}

export default CMSRoute